module.exports = __webpack_public_path__ + "static/media/map-marker-info.ab244612.svg";